import { styled, Flex, Box, selectTheme, ifProp } from '@creditas-ui/react';
import { ChevronDown } from '@/assets/icons/ChevronDown';

type ChevronIconState = {
  active: boolean;
};

const Profile = styled(Flex)`
  align-items: center;
`;

const Content = styled.div`
  display: flex;
  height: 100%;
  align-items: flex-end;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;
  margin-right: ${selectTheme('spacingRight.6xl')};
`;

const Info = styled(Box)`
  position: relative;
  width: 100%;
`;

const Label = styled(Flex)`
  align-items: center;
`;

const ChevronIcon = styled(ChevronDown)<ChevronIconState>`
  margin-left: ${selectTheme('spacingLeft.md')};
  transform: ${ifProp('active', 'rotate(0)', 'rotate(180deg)')};
`;

export { Profile, Content, Info, Label, ChevronIcon };
